/**
 * Playio Upsell v1.5 — domyślna konfiguracja (PL fallback).
 *
 * FREE-ALL: darmowa dostawa dla każdego zamówienia (tier1.threshold = 0).
 * Jedyny próg-nagroda: prezent (pistolet na bańki) od tier2.threshold.
 *
 * Per-market config siedzi w snippets/playio-progress-bar.liquid (case localization.market.handle).
 * Snippet uruchamia się INLINE w body — przed defer scriptami.
 * Ten plik (defer) ustawia konfig TYLKO jeśli snippet jeszcze go nie ustawił
 * (np. strony bez progress bara).
 *
 * Po zmianie zbumpuj cache-bust w theme.liquid.
 */
(function () {
  if (window.PlayioConfig && window.PlayioConfig.currency) {
    // Snippet już ustawił config per-market. Nie nadpisuj.
    return;
  }

  window.PlayioConfig = {
    currency: 'PLN',
    locale: 'pl-PL',

    shipping: {
      tier1: { threshold: 0, label: 'Darmowa dostawa' },
      tier2: {
        threshold: 24900,
        label: 'Prezent za 1 gr',
        activeDuringPromo: true,
        giftProductHandle: 'bubble-maker-playio-pistolet-do-baniek-mydlanych-z-dinozaurem',
        giftVariantId: 54051138273626,
        giftAutoAdd: true
      }
    },

    gift: {
      fallbackName: 'Pistolet do baniek mydlanych PLAYIO Dinozaur',
      fallbackImage: '',
      lineItemFlag: '_playio_gift'
    },

    promo: {
      enabled: true,
      endsAt: '2026-04-29T23:59:59+02:00',
      bundleMinItems: 2,
      bundleDiscountPercent: 10,
      eligibleTag: 'przedsprzedaz'
    },

    copy: {
      below_tier1_line1: '✅ Darmowa dostawa — na każde zamówienie',
      below_tier1_line2: '',

      at_tier1_below_tier2_line1: '✅ Darmowa dostawa — na każde zamówienie',
      at_tier1_below_tier2_line2: 'Dodaj <strong>{amount}</strong> więcej i otrzymasz <strong>{giftName}</strong> za 1 gr 🎁',

      at_tier2_line1: '✅ Darmowa dostawa — na każde zamówienie',
      at_tier2_line2: '🎁 <strong>{giftName}</strong> za 1 gr w paczce',

      at_tier1_promo_line1: '✅ Darmowa dostawa — na każde zamówienie',
      at_tier1_promo_line2: ''
    },

    selectors: {
      progressContainer: '[data-playio-progress]'
    }
  };
})();
